import { useTranslation } from 'react-i18next'

function clockTime(iso, language) {
  if (!iso) return ''
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ''
  return date.toLocaleTimeString(language, { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
}

// The sync state of the tenant's FAQ. The wording says "Bot đã cập nhật" only
// when the bot really uses the FAQ; otherwise it speaks of syncing only.
// Failures come first: they are the state the manager can act on.
export default function FaqSyncChip({ status, botUsesFaq, canWrite, onRetry, retrying = false }) {
  const { t, i18n } = useTranslation()
  if (!status || status.total === 0) return null

  const mode = botUsesFaq ? 'bot' : 'neutral'
  const number = (value) => Number(value).toLocaleString(i18n.language)
  const busy = status.pending + status.syncing
  const time = clockTime(status.last_synced_at, i18n.language)
  let tone = 'border-emerald-200 bg-emerald-50 text-emerald-700'
  let text = time ? t(`faq.chip.${mode}.synced`, { time }) : t(`faq.chip.${mode}.syncedNoTime`)
  if (status.failed > 0) {
    tone = 'border-red-200 bg-red-50 text-red-700'
    text = t(`faq.chip.${mode}.failed`, { count: status.failed, formatted: number(status.failed) })
  } else if (busy > 0) {
    tone = 'border-amber-200 bg-amber-50 text-amber-700'
    text = t(`faq.chip.${mode}.syncing`, { count: busy, formatted: number(busy) })
  }
  const offerRetry = status.failed > 0 && canWrite

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold ${tone}`}>
      <span aria-live="polite">{text}</span>
      {offerRetry && <span aria-hidden="true">·</span>}
      {offerRetry && (
        <button
          type="button"
          onClick={onRetry}
          disabled={retrying}
          className="underline underline-offset-2 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {t('faq.chip.retry')}
        </button>
      )}
    </span>
  )
}
